import { ThemeProvider } from '@mui/material/styles';
import Navigation from '../../components/Navigation/Navigation';
import { theme } from './theme';

const MainLayout = props => {
	return (
		<ThemeProvider theme={theme}>
			<Navigation>{props.children}</Navigation>
		</ThemeProvider>
	);
};

export default MainLayout;
